const __WEBPACK_NAMESPACE_OBJECT__ = require("xml-but-prettier");